import {
  SoftwareOnboardingLayout,
  SoftwareOnboardingMain,
  SoftwareOnboardingHeader,
  SoftwareOnboardingFooter,
  SoftwareOnboardingProgress,
} from 'src/components/SoftwareOnboarding';

import { SoftwareEscrowNewContextProvider } from './model';
import { RoleAndAgreementSettings, CreateAction, ExitAlertDialog } from './ui';

const SoftwareEscrowOnboardingNew = () => {
  return (
    <SoftwareEscrowNewContextProvider>
      <SoftwareOnboardingLayout>
        <SoftwareOnboardingHeader>
          <SoftwareOnboardingProgress currentStep={1} totalSteps={10} completedStep={0} />
          <ExitAlertDialog />
        </SoftwareOnboardingHeader>
        <SoftwareOnboardingMain
          title="Create your new escrow"
          description="Start by configuring the essential details of your escrow."
          noteText="Once saved, these settings can’t be changed — so take a moment to review everything before submitting."
        >
          <div className="container mx-auto grid grid-cols-1 gap-8 md:grid-cols-2">
            <RoleAndAgreementSettings />
          </div>
        </SoftwareOnboardingMain>
        <SoftwareOnboardingFooter justify="end">
          <CreateAction />
        </SoftwareOnboardingFooter>
      </SoftwareOnboardingLayout>
    </SoftwareEscrowNewContextProvider>
  );
};

export default SoftwareEscrowOnboardingNew;
